import { ARTIFACT_FILE_TYPES, type ArtifactFileType } from '@/entities/artifact/domain/constants';

export const getFileExtension = (path: string): string => {
  const parts = path.split('.');
  return parts.length > 1 ? parts.pop()?.toLowerCase() || '' : '';
};

export type FileType = ArtifactFileType;

export const getFileType = (path: string): FileType => {
  const ext = getFileExtension(path);
  const fileName = path.split('/').pop()?.toLowerCase() || '';

  if (['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'].includes(ext)) {
    return ARTIFACT_FILE_TYPES.IMAGE;
  }

  if (['json'].includes(ext)) {
    return ARTIFACT_FILE_TYPES.JSON;
  }

  const specialTextFiles = ['mlmodel', 'requirements.txt', 'conda.yaml', 'python_env.yaml'];

  if (
    ['txt', 'log', 'yaml', 'yml', 'md', 'py', 'sh', 'sql', 'csv'].includes(ext) ||
    specialTextFiles.includes(fileName)
  ) {
    return ARTIFACT_FILE_TYPES.TEXT;
  }

  return ARTIFACT_FILE_TYPES.UNSUPPORTED;
};

export const formatFileSize = (bytes?: number): string => {
  if (bytes === undefined || bytes === null) return '-';
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
